module.exports = __webpack_public_path__ + "img/Villa_Borna_22.19f1593c.jpg";